import Vue from 'vue'
import App from './App.vue'
import router from './router'
import XLSX from 'xlsx'
import VCharts from 'v-charts'
import './plugins/element.js'
// 导入全局样式表
import './assets/css/global.css'

import axios from 'axios'
import moment from 'moment'
// 导入mock
// import './mock/'

// axios.defaults.baseURL = 'http://192.168.5.68:8082'
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
// axios.defaults.baseURL = 'http://localhost:8080'

axios.interceptors.request.use(config => {
  // 挂载请求头
  config.headers.Authorization = window.localStorage.getItem('token')
  return config
})
axios.interceptors.response.use(
  response => {
    const res = response.data
    // 登录已过期
    if (res.StatusCode === 100) {
      Vue.prototype.$message.error(res.Msg)
      router.replace({ path: '/login' })
      // 授权码错误
    } else if (res.StatusCode === 101) {
      Vue.prototype.$message.error(res.Msg)
    }
    return response
  }
)
Vue.prototype.$http = axios
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.use(XLSX)
Vue.use(VCharts)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
